import { Button, Modal } from "antd";

export interface ConfirmDeleteUploadedFontModalProps {
  isVisible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmDeleteUploadedFontModal({
  isVisible,
  onCancel,
  onConfirm,
}: ConfirmDeleteUploadedFontModalProps) {
  return (
    <Modal
      className={"clean one"}
      onCancel={() => onCancel()}
      visible={isVisible}
    >
      <header>
        <h2>Are you sure?</h2>
      </header>

      <p>This font will be removed from your library.</p>

      <footer>
        <Button size={"large"} onClick={() => onCancel()}>
          Cancel
        </Button>
        <Button size={"large"} className={"primary"} onClick={onConfirm}>
          Ok
        </Button>
      </footer>
    </Modal>
  );
}
